<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2019-09-20 13:32:40
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div id="page_Container">
        <div class="page">
            <div id='main-container' class="main-container">
                <div id='boxNew'>
                    <div class='boxD'>
                        <div class='inBox'>
                            <h4>
                                <img :src="inteUrl" alt="">
                                <span>可用积分</span>
                            </h4>
                            <h5>{{logDetails.total}}</h5>
                        </div>
                        <div class='mx'>
                            <span>积分明细</span>
                        </div>
                    </div>
                    <div class='box'>
                        <div class='boxList'>
                            <div class='aaBox' v-if='listShow'>
                                <van-list v-model="ploading" :finished="finished" @load="onLoad">
                                    <div class='list' v-for='item in list' :key='item.id'>
                                        <van-row>
                                            <van-col span="16">
                                                <p class='p1'>{{item.typeStr}}</p>
                                                <p class='p2'>{{item.createTime}}</p>
                                            </van-col>
                                            <van-col span="8" class='pointCol'>{{item.pointStr}}</van-col>
                                        </van-row>
                                    </div>
                                </van-list>
                            </div>
                            <div v-if='!listShow' class='listBoxStyle'>
                                <img :src="noJfUrl" alt="">
                                <p>暂无积分哦！</p>
                            </div>
                        </div>
                        <div class='divBottomStyle'>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { toastLoading, clearToastLoading } from '@/utils/base/utils';

export default {
    data() {
        return {
            logDetails: {},
            inteUrl: require('../assets/img/myCenter/inte.png'),
            noJfUrl: require('../assets/img/myCenter/noJf.png'),
            pageNum: 1,
            pageSize: 10,
            ploading: false,
            finished: true,
            list: [],
            listShow: true
        };
    },

    esvReady() {
        this.pageNum = 1;
        this.queryScoreItemList();
    },
    methods: {
        queryScoreItemList() {
            const ths = this;
            const params = {
                pageNum: this.pageNum,
                pageSize: this.pageSize
            };
            ths.$doRequest(
                {
                    url: '/point/queryMemberPointInfo',
                    params: params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        ths.finished = true;
                        ths.ploading = false;
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    ths.logDetails = data.result;
                    const total = data.result.memberAccountPointRecordList.total;
                    ths.list = ths.pageNum === 1 ? data.result.memberAccountPointRecordList.list : [...ths.list, ...data.result.memberAccountPointRecordList.list];
                    if (ths.list.length < total) {
                        ths.finished = false;
                    } else {
                        ths.finished = true;
                    }

                    if (ths.list.length > 0) {
                        ths.listShow = true;
                    } else {
                        ths.listShow = false;
                    }
                }
            );
        },
        onLoad() {
            this.pageNum++;
            this.queryScoreItemList();
        }
    }
};
</script>
<style lang="scss" scoped>
.boxD {
    width: 100%;
    background: #f2f2f2;
    .inBox {
        margin: 12px;
        background-image: linear-gradient(-180deg, #ef4274 0%, #ee3556 100%);
        box-shadow: 0 4px 8px 0 rgba(238, 46, 80, 0.38);
        padding: 0 12px;
        position: relative;
        h4 {
            position: absolute;
            top:10px;
            height: 30px;
            line-height: 30px;
            img {
                width: 20px;
                float: left;
                margin: 6px 6px 0 0;
            }
            span {
                font-weight: 500;
                color: white;
            }
        }
        h5 {
            text-align: center;
            color: white;
            padding: 50px 0;
            font-size: 30px;
        }
    }
    .mx {
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #414141;
        letter-spacing: 0;
        text-align: left;
        padding: 10px 12px;
        span {
            display: inline-block;
            border-left: 3px solid #ee2e50;
            padding-left: 12px;
            margin-left: 10px;
        }
    }
}
.box {
    padding: 0 12px;
    .boxList {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
        border-radius: 4px;
        h4 {
            padding: 0 12px;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #414141;
            letter-spacing: 0;
            text-align: left;
            padding: 15px 0;
            span {
                display: inline-block;
                border-left: 3px solid #ee2e50;
                padding-left: 12px;
                margin-left: 10px;
            }
        }
        .list {
            overflow: hidden;
            background: #fff;
            padding: 10px;
            border-bottom: 1px dotted #e3e2e2;
        }
    }
}
.p1 {
    font-size: 14px;
    margin-bottom: 2px;
}
.p2 {
    font-size: 12px;
    color: #999;
}
.pointCol {
    color: #ee2e50;
    text-align: right;
}
.listBoxStyle {
    text-align: center;
    background: #fff;
    overflow: hidden;
    img {
        width: 146px;
        margin-top: 40px;
    }
    p {
        color: #999;
        padding-top: 10px;
        text-align: center;
        margin-bottom: 40px;
    }
}
.divBottomStyle {
    padding: 10px 0;
    text-align: center;
    color: #999;
}
</style>
